import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Http from "axios";
import config from "../config";
import { inject, observer } from "mobx-react";

@inject("UserStore")
@observer
class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: null,
      email: null,
      firstName: null,
      lastName: null,
      password: null
    };
  }
  handleSubmit(e) {
    const { username, email, firstName, lastName, password } = this.state;
    e.preventDefault();

    Http.post(
      config.api + "/register",
      {
        username,
        email,
        firstName,
        lastName,
        password
      },
      { withCredentials: true }
    )
      .then(res => {
        this.props.UserStore.getMyStats();
      })
      .catch(err => {
        console.error(err);
      });
  }
  render() {
    return (
      <div className="cred-area">
        <form className="login-holder" onSubmit={this.handleSubmit.bind(this)}>
          <h3>Register</h3>
          <input
            type="text"
            placeholder="Username"
            onChange={e =>
              this.setState({
                username: e.target.value
              })
            }
          />
          <input
            type="text"
            placeholder="First Name"
            onChange={e =>
              this.setState({
                firstName: e.target.value
              })
            }
          />
          <input
            type="text"
            placeholder="Last Name"
            onChange={e =>
              this.setState({
                lastName: e.target.value
              })
            }
          />
          <input
            type="email"
            placeholder="Your Email"
            onChange={e =>
              this.setState({
                email: e.target.value
              })
            }
          />
          <input
            type="password"
            placeholder="Password"
            onChange={e =>
              this.setState({
                password: e.target.value
              })
            }
          />
          <button>Create Account</button>
          {this.props.UserStore.user.username ? <Redirect to="/Login" /> : null}
          <p>
          Have an account already? <Link to="/Login">Login Here</Link>
          </p>
        </form>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Register.js